import React from 'react';
import { reportResults, apiRoutes, routes, contentTypes, fetchTypes } from '../constants';
import { DataGrid, DataColumn, DateGridCell, LinkGridCell, StatusGridCell, Input, Button } from '../components';
import { ResourceUtils, ReportCSV } from '../utils';
import { ResourceActions } from '../actions';
import store from '../store';
import moment from 'moment';

class CompletedReportGrid extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            multiselecting: false,
            multiselected: {}
        }
    }

    resultTypeFilter(data) {
        let results = {};
        results[reportResults.NO_ACTION_REQUIRED] = StatusGridCell.status.POSITIVE;
        results[reportResults.MARGINAL_RESULTS] = StatusGridCell.status.WARNING;
        results[reportResults.ACTION_REQUIRED] = StatusGridCell.status.ERROR;
        results[reportResults.PENDING] = StatusGridCell.status.PENDING;

        return results[data] || results[reportResults.PENDING];
    }

    savePdf(dataRow) {
        const url = apiRoutes.REPORT_PDF_BASE + dataRow.id;
        const token = store.getState().activeUser['access_token'];

        ResourceUtils.fetchAsBlob(url, {
            contentType: contentTypes.APPLICATION_PDF,
            token: token
        })
            .then(blob => {
                ResourceUtils.downloadBlob(blob, {
                    target: '_blank',
                    fileName: `report-${dataRow.id}.pdf`
                });
            });
    }

    exportCSV(id) {
        store.dispatch(ResourceActions.resourceFetch(fetchTypes.REPORT_DATA, {
            reportId: id, method: 'Csv'
        }, {
                onSuccess: (payload) => {
                    let csv = new ReportCSV(payload);
                    csv.save();
                }
            }));
    }

    sampleTrendingLinkFilter(rowData) {
        return `${routes.SAMPLE_TRENDING_BASE}${rowData.id}`
    }

    startMultiSelect() {
        this.setState({
            multiselecting: true
        });
    }

    cancelMultiSelect() {
        this.setState({
            multiselecting: false,
            multiselected: {}
        });
    }

    toggleMultiSelect(item) {
        if (!!this.state.multiselected[item.id]) {
            let obj = Object.assign({}, this.state.multiselected);
            delete obj[item.id];
            this.setState({
                multiselected: obj
            });
        } else {
            let obj = {};
            obj[item.id] = item;
            this.setState({
                multiselected: Object.assign({}, this.state.multiselected, obj)
            });
        }
    }

    export() {

        let url = apiRoutes.REPORT_EXPORT
        const token = store.getState().activeUser['access_token'];

        Object.keys(this.state.multiselected).map(key => {
            url += `&reportId=${encodeURIComponent(key)}&method=ExcelBatch`;
        })
        ResourceUtils.fetchAsBlob(url, {
            contentType: contentTypes.VND_OPENXML,
            token: token
        })
            .then(blob => {
                ResourceUtils.downloadBlob(blob, {
                    target: '_blank',
                    fileName: `${new moment().format('YYYY-MM-DD')}-export.csv`
                });
            })
            .then(() => this.cancelMultiSelect());
    }

    render() {
        return (
            <DataGrid {...this.props} className={['component-completed-report-grid', this.props.className].join(' ') }>
                <DataColumn columnName="sampleNumber" displayName="Report Number" />
                <DataColumn columnName="result" displayName="Result" filter={data => this.resultTypeFilter(data) } cellComponent={StatusGridCell}/>
                <DataColumn columnName="customerName" displayName="Customer" />
                <DataColumn columnName="serialNumber" displayName="Serial Number" />
                <DataColumn columnName="reportDate" displayName="Report Date" cellComponent={DateGridCell} />
                <DataColumn className="link-mobile-button" columnName="trendingLink" displayName="" cellComponent={LinkGridCell} filter={(data, rowData) => this.sampleTrendingLinkFilter(rowData) } cellComponentProps={{ text: 'Trends' }} />
                <DataColumn className="link-mobile-button" columnName="reportLink" displayName="" cellComponent={LinkGridCell} cellComponentProps={{ text: 'PDF', target: '_blank', onClick: (e, data, dataRow) => this.savePdf(dataRow) }} />
                <DataColumn className="link-mobile-button" columnName="csvLink" displayName=""
                    cellComponent={
                        (props) => {
                            if (this.state.multiselecting) {
                                return (<Input type="checkbox" checked={!!this.state.multiselected[props.rowData.id]} onClick={() => this.toggleMultiSelect(props.rowData) } />);
                            } else {
                                let linkProps = Object.assign({ text: 'CSV', onClick: (e, data, dataRow) => this.exportCSV(dataRow.id) }, props)
                                return (<LinkGridCell {...linkProps} />);
                            }
                        }
                    } cellComponentProps={{ text: 'CSV', onClick: (e, data, dataRow) => this.exportCSV(dataRow.id) }}
                    headerComponent={
                        () => {
                            if (this.state.multiselecting) {
                                if (Object.keys(this.state.multiselected).length > 0) {
                                    return (<Button onClick={() => this.export(this.state.multiselected) } className="primary">Export</Button>)
                                } else {
                                    return (<Button onClick={() => this.cancelMultiSelect() }>Cancel</Button>);
                                }
                            } else {
                                return (<Button onClick={() => this.startMultiSelect() }>Multi-Select</Button>)
                            }
                        }
                    } />

            </DataGrid>
        )
    }
}

export default CompletedReportGrid;



// WEBPACK FOOTER //
// ./web-app/components/completed-report-grid.jsx